import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * Input para frequência cardíaca mínima de treino
 */
export const TextFieldMinTrainingHeartRate = ({
    values,
    handleChange,
    errors,
    touched
}) => (
    <TextField
        fullWidth
        label={t('users.fields.minTrainingHR')}
        type="tel"
        name="minTrainingHeartRate"
        value={values.minTrainingHeartRate}
        error={touched.minTrainingHeartRate && Boolean(errors.minTrainingHeartRate)}
        helperText={touched.minTrainingHeartRate && errors.minTrainingHeartRate}
        onChange={handleChange}
    />
);

TextFieldMinTrainingHeartRate.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
